// Thin wrapper around Meta Pixel's fbq() so SPA code can safely call events
// even if the pixel script hasn't loaded yet (fbq queues internally).

const safeFbq = (...args) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq(...args);
    }
  } catch (e) {
    /* never let analytics break the UI */
  }
};

export const trackPageView = () => safeFbq("track", "PageView");

export const trackViewContent = ({ id, name, price, currency = "INR" }) =>
  safeFbq("track", "ViewContent", {
    content_ids: id ? [id] : undefined,
    content_name: name,
    content_type: "product",
    value: price,
    currency,
  });

export const trackAddToCart = ({ id, name, price, currency = "INR", qty = 1 }) =>
  safeFbq("track", "AddToCart", {
    content_ids: id ? [id] : undefined,
    content_name: name,
    content_type: "product",
    value: price * qty,
    currency,
    contents: id ? [{ id, quantity: qty }] : undefined,
  });

export const trackInitiateCheckout = ({ items = [], value, currency = "INR" } = {}) =>
  safeFbq("track", "InitiateCheckout", {
    content_ids: items.map((i) => i.id).filter(Boolean),
    contents: items.map((i) => ({ id: i.id, quantity: i.quantity || 1 })),
    num_items: items.reduce((n, i) => n + (i.quantity || 1), 0),
    value,
    currency,
  });
